export default __webpack_public_path__ + "static/media/darkAgentLogo.a216e469.svg";